const STORAGE_MIGRATION_MARKER = "mozzoapp:storage-migrated:v1";

const STORAGE_PREFIX_MIGRATIONS = [
  ["restoapp:", "mozzoapp:"],
  ["restoapp-", "mozzoapp-"],
];

const copyStorageNamespace = (storage) => {
  if (!storage) {
    return;
  }

  const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index)).filter(
    Boolean
  );

  keys.forEach((key) => {
    STORAGE_PREFIX_MIGRATIONS.forEach(([legacyPrefix, nextPrefix]) => {
      if (!key.startsWith(legacyPrefix)) {
        return;
      }

      const nextKey = `${nextPrefix}${key.slice(legacyPrefix.length)}`;

      if (storage.getItem(nextKey) !== null) {
        return;
      }

      const value = storage.getItem(key);
      if (value === null) {
        return;
      }

      storage.setItem(nextKey, value);
    });
  });
};

export const migrateStorageNamespaces = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (window.__mozzoappStorageMigrationDone) {
    return;
  }

  try {
    copyStorageNamespace(window.localStorage);
    window.localStorage.setItem(STORAGE_MIGRATION_MARKER, "1");
  } catch (error) {
    // Si el navegador esta al limite, seguimos sin bloquear la app.
  }

  try {
    copyStorageNamespace(window.sessionStorage);
    window.sessionStorage.setItem(STORAGE_MIGRATION_MARKER, "1");
  } catch (error) {
    // Session storage tambien es optativo; no frenamos el arranque.
  }

  window.__mozzoappStorageMigrationDone = true;
};
